import { render, staticRenderFns } from "./RepositoryView.vue?vue&type=template&id=2bec6bca&lang=pug"
import script from "./RepositoryView.vue?vue&type=script&lang=ts"
export * from "./RepositoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bec6bca')) {
      api.createRecord('2bec6bca', component.options)
    } else {
      api.reload('2bec6bca', component.options)
    }
    module.hot.accept("./RepositoryView.vue?vue&type=template&id=2bec6bca&lang=pug", function () {
      api.rerender('2bec6bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Repository/RepositoryView.vue"
export default component.exports